
/* BANNER */
export const GET_BANNER_LISTING = "GET_BANNER_LISTING";
export const GET_BANNER_LISTING_SUCCESS = "GET_BANNER_LISTING_SUCCESS";
export const GET_BANNER_LISTING_FAIL = "GET_BANNER_LISTING_FAIL";

export const GET_BANNER_DETAILS = "GET_BANNER_DETAILS";
export const GET_BANNER_DETAILS_SUCCESS = "GET_BANNER_DETAILS_SUCCESS";
export const GET_BANNER_DETAILS_FAIL = "GET_BANNER_DETAILS_FAIL";

export const ADD_BANNER = "ADD_BANNER";
export const ADD_BANNER_SUCCESS = "ADD_BANNER_SUCCESS";
export const ADD_BANNER_FAIL = "ADD_BANNER_FAIL";

export const UPDATE_BANNER = "UPDATE_BANNER";
export const UPDATE_BANNER_SUCCESS = "UPDATE_BANNER_SUCCESS";
export const UPDATE_BANNER_FAIL = "UPDATE_BANNER_FAIL";

export const DELETE_BANNER = "DELETE_BANNER";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";
export const DELETE_BANNER_FAIL = "DELETE_BANNER_FAIL";

export const EXPORT_BANNER = "EXPORT_BANNER";
export const EXPORT_BANNER_SUCCESS = "EXPORT_BANNER_SUCCESS";
export const EXPORT_BANNER_FAIL = "EXPORT_BANNER_FAIL";

export const RESET_BANNER_STATE = 'RESET_BANNER_STATE';
export const RESET_BANNER_ATTACHMENT_STATE = 'RESET_BANNER_ATTACHMENT_STATE';